// src/components/PhiBadge.jsx
// Header badge for clients that handle PHI (3.19.9: Control Panel → Clients
// → "Handles PHI (HIPAA)"). An icon; hovering or focusing it shows a short
// note. Not shown for other clients, or on All clients.
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../hooks/useAuth';
import Emo from './Emo';

// 3.48.4: one short line, so it doesn't cover the menu bar
export const PHI_NOTE = 'Handles PHI under HIPAA safeguards';

// 3.62.27 (owner): compact (phones) = the shield alone, no "HIPAA" word
export default function PhiBadge({ compact = false }) {
  const { effectiveInfo } = useAuth();
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  if (!effectiveInfo?.hipaa) return null;
  return (
    <span ref={ref} style={S.wrap} tabIndex={0} aria-label={PHI_NOTE}
      onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} onFocus={() => setShow(true)} onBlur={() => setShow(false)}
      onClick={() => setShow(true)}>   {/* phones: a tap shows the note */}
      <span style={compact ? { ...S.badge, padding: '5px 7px' } : S.badge} className="phi-badge" aria-hidden="true" title={compact ? 'HIPAA' : undefined}><span className="phi-shield"><Emo e="🛡️" /></span>{compact ? '' : ' HIPAA'}</span>
      {show && !compact && <span role="tooltip" style={S.tip}>{PHI_NOTE}</span>}
      {/* phones: the header row clips, so the note goes on top of the page, under the shield */}
      {show && compact && ref.current && createPortal((() => {
        const r = ref.current.getBoundingClientRect();
        return <span role="tooltip" style={{ ...S.tipBelow, top: r.bottom + 6, left: Math.max(8, Math.min(r.left, window.innerWidth - 248)) }}>{PHI_NOTE}</span>;
      })(), document.body)}
    </span>
  );
}

const S = {
  wrap: { position: 'relative', display: 'inline-flex', outline: 'none' },
  badge: { display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 10px', borderRadius: 20, border: '1.5px solid var(--c-b2dfdb)', background: 'var(--c-f0faf8)', color: 'var(--t-00695c)', fontSize: 12, fontWeight: 700, cursor: 'default', whiteSpace: 'nowrap' },   // no "?" cursor (3.19.10)
  tip: { position: 'absolute', top: '50%', left: 'calc(100% + 8px)', transform: 'translateY(-50%)', whiteSpace: 'nowrap',   // beside the badge, clear of the menu bar (3.48.4)
    padding: '6px 10px', background: 'var(--c-37474f)', color: 'var(--t-ffffff)', borderRadius: 6, boxShadow: '0 4px 14px rgb(var(--c-000000-rgb) / 0.18)', fontSize: 12, lineHeight: 1.4, fontWeight: 400, zIndex: 320, pointerEvents: 'none' },
  // phones: under the shield, so the note stays on screen
  tipBelow: { position: 'fixed', whiteSpace: 'nowrap',
    padding: '6px 10px', background: 'var(--c-37474f)', color: 'var(--t-ffffff)', borderRadius: 6, boxShadow: '0 4px 14px rgb(var(--c-000000-rgb) / 0.18)', fontSize: 12, lineHeight: 1.4, fontWeight: 400, zIndex: 2000, pointerEvents: 'none' },
};
